import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "../layouts/AppShell";
import { useAuth } from "./AuthProvider";
import { Skeleton } from "../components/Skeleton";
import { AuthPage } from "../pages/AuthPage";
import { OnboardingPage } from "../pages/OnboardingPage";
import { TodayPage } from "../pages/TodayPage";
import { AnalyticsPage } from "../pages/AnalyticsPage";
import { ReportsPage } from "../pages/ReportsPage";
import { SettingsPage } from "../pages/SettingsPage";
import { AdminPage } from "../pages/AdminPage";
import { canAccessAdmin } from "../lib/permissions";
import { getAuthRedirect } from "../routes/guards";

export function App() {
  return (
    <Routes>
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/auth/invite" element={<AuthPage />} />
      <Route element={<RequireAuth />}>
        <Route path="/" element={<Navigate to="/today" replace />} />
        <Route path="/onboarding" element={<OnboardingPage />} />
        <Route element={<AppShell />}>
          <Route path="/today" element={<TodayPage />} />
          <Route path="/analytics" element={<AnalyticsPage />} />
          <Route path="/history" element={<Navigate to="/analytics" replace />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/admin" element={<RequireAdmin />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/today" replace />} />
    </Routes>
  );
}

function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="auth-screen">
        <div className="auth-panel panel">
          <Skeleton rows={4} />
        </div>
      </div>
    );
  }

  const redirect = getAuthRedirect(user, loading, location.pathname);
  if (redirect) {
    return <Navigate to={redirect} replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

function RequireAdmin() {
  const { user } = useAuth();
  if (!canAccessAdmin(user)) {
    return <Navigate to="/today" replace />;
  }
  return <AdminPage />;
}
